import { useState, useCallback } from 'react';

import { HowToEarnPointsModalOptions, ModalContextValue } from '../ModalContext.types';

export const useHowToEarnPointsModal = (): ModalContextValue['howToEarnPoints'] => {
    const [isOpen, setOpen] = useState(false);

    const open = useCallback((_options: HowToEarnPointsModalOptions = {}) => {
        setOpen(true);
    }, []);

    const close = useCallback(() => setOpen(false), []);

    return { isOpen, open, close };
};
